(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('SSPerfilDeleteController',SSPerfilDeleteController);

    SSPerfilDeleteController.$inject = ['$uibModalInstance', 'entity', 'SSPerfil'];

    function SSPerfilDeleteController($uibModalInstance, entity, SSPerfil) {
        var vm = this;

        vm.sSPerfil = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            SSPerfil.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
